import styled from 'styled-components';
import breakpoints from 'theme/atoms/breakpoints';
import {
  Page,
  Content,
  ContentContainer,
} from 'layout/styles/PageLayout.style';

export const DashboardPage = styled(Page)`
  @media (max-width: ${breakpoints.tablet}) {
    padding: 80px 0 0;
  }
`;

export const DashboardContentContainer = styled(ContentContainer)`
  &::after {
    content: '';
    display: block;
    min-height: 30px;
    flex-shrink: 0;
  }
`;

export const DashboardContent = styled(Content)`
  height: auto;

  @media (max-width: ${breakpoints.tablet}) {
    padding: 0 15px 20px;
  }
`;

export const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 60px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
  }
`;

export const FiltersRow = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: ${breakpoints.tablet}) {
    max-width: 100%;
  }
`;

export const WidgetGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 10px;
  width: 100%;
`;
